import { connect } from 'react-redux';
import { TooltippedSpan } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { ResourceState } from '@mews-commander/data-access';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { ResourceState as ResourceStateLegacy } from '@mews-commander/legacy-data-structures';
import { getColorFromResourceState } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getResourceState } from '@mews-commander/legacy-entities/src/ducks/resources';
import { navigateToResourceState } from '../../shortcuts';
import { ResourceCategoryNameByResource } from '../../../components/commander-ui';
import { ResourceName } from '../../../components/reservation/ResourceName';
import { ResourceElement } from './styles';

interface OwnProps {
    resourceId: string;
    serviceId: string;
}
interface StateProps {
    state: ResourceState | undefined;
}
interface DispatchProps {
    navigateToResource: () => void;
}
type Props = StateProps & DispatchProps & OwnProps;

const ResourceDetail = ({ state, navigateToResource, resourceId, serviceId }: Props) => {
    const color = getColorFromResourceState(state && ResourceStateLegacy.getByName(state).value);
    return (
        <ResourceElement color={color} onClick={navigateToResource} inherit>
            <TooltippedSpan tooltip={<ResourceCategoryNameByResource resourceId={resourceId} serviceId={serviceId} />}>
                <ResourceName resourceId={resourceId} />
                {UnicodeEntity.NoBreakSpace}
                <ResourceCategoryNameByResource resourceId={resourceId} serviceId={serviceId} short />
            </TooltippedSpan>
        </ResourceElement>
    );
};

export default connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    (state, { resourceId }) => ({
        state: getResourceState(state, { id: resourceId, enterpriseId: getCurrentEnterpriseId() }),
    }),
    (dispatch: CommanderThunkDispatch, { resourceId }) => ({
        navigateToResource: () => dispatch(navigateToResourceState(resourceId)),
    })
)(ResourceDetail);
